import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '@components/common/Button';
import '../../../pages/Beneficiary-block/CreateBeneficiary/FaceAuthentication/reAuthenticationModal.css';

interface UserReAuthenticationModalProps {
  showModal: boolean;
  handleClose: (confirmed: boolean) => void;
  userData: {
    abhaNumber: string;
  };
  abdmData?: {
    name: string;
    abhaId: string;
  };
}

const UserReAuthenticationModal: React.FC<UserReAuthenticationModalProps> = ({
  showModal,
  handleClose,
  userData,
  abdmData,
}) => {
  const jananiAbha = (userData?.abhaNumber || '').replace(/-/g, '');
  const abdmAbha = (abdmData?.abhaId || '').replace(/-/g, '');

  const isAbhaMatch = jananiAbha === abdmAbha;

  return (
    <Modal
      show={showModal}
      onHide={() => handleClose(false)}
      centered
      backdrop="static"
      dialogClassName="re-auth-modal-dialog"
    >
      <Modal.Header closeButton className="re-auth-modal-header">
        <Modal.Title className="re-auth-modal-title">
          Re-Authentication
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="re-auth-modal-body">
        <p className="re-auth-modal-description">
          ASHA details mismatch detected. Please review.
        </p>

        <div className="re-auth-comparison-table">
          <div className="re-auth-table-header">
            <div className="re-auth-table-field-col"></div>
            <div className="re-auth-table-rch-col">JANANI Data</div>
            <div className="re-auth-table-abdm-col">ABDM Data</div>
          </div>

          <div className="re-auth-table-row">
            <div className="re-auth-table-field-col">ABHA Number</div>
            <div className="re-auth-table-rch-col">
              {userData?.abhaNumber || '-'}
            </div>
            <div className="re-auth-table-abdm-col">
              {abdmData?.abhaId || '-'}
              {abdmData?.abhaId && userData?.abhaNumber && (
                <span
                  className={`re-auth-match-icon ${
                    isAbhaMatch ? 're-auth-match' : 're-auth-mismatch'
                  }`}
                >
                  {isAbhaMatch ? '✔' : '⚠'}
                </span>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="re-auth-modal-footer">
        <Button
          onClick={() => handleClose(false)}
          buttonName="Close"
          colorType="primary"
          id="re-auth-close-btn"
          dataTestId="re-auth-user-close-btn"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default UserReAuthenticationModal;
